import Vue from 'vue'
import Vuex from 'vuex'
import navtabs from './modules/navtabs.js'
import user from './modules/user.js'
import dictionary from './modules/async-dictionary.js'
import cg_cascader from './modules/category-cascader.js'
import tbForm from './modules/tb-form.js'
import tjbForm from './modules/tjb-form.js'
import alibabaForm from './modules/alibaba-form.js'
import shops from './modules/shops.js'
import tmall from './modules/tmall.js'
import supplierName from "./modules/supplier-name.js";
import dr_selectedProds from './modules/distributeRules-selectedProds.js'
import distributorPrice from './modules/distributorPrice.js'
import tableCols from './modules/table-cols.js'
import queryPublishSpeed from './modules/publishSpeed.js'
import operatorLog from './modules/operator-log.js'
import commodityGoodsList from '@/pages/supplier/commodity/components/List/store/index.js'
import orderAudit from './modules/trade/orderAudit';// 订单处理
import print from '@print/store/'
import unlogin from "./modules/unlogin.js"
import image from "./modules/image.js"
import defaultSearchImageList from "./modules/defaultSearchImageList.js"
import platformQuota from "./modules/platformQuota.js"
import { confModule, caches } from './modules/mixture.js'
import common from './modules/common.js'
import fxgProdSuggest from './modules/fxgProdSuggest.js'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        navtabs,
        user,
        dictionary,
        cg_cascader,
        tbForm,
        tjbForm,
        shops,
        alibabaForm,
        tmall,
        supplierName,
        dr_selectedProds,
        distributorPrice,
        tableCols,
        queryPublishSpeed,
        operatorLog,
        orderAudit, // 订单处理
        print,
        commodityGoodsList,
        unlogin,
        image,
        defaultSearchImageList,
        platformQuota,
        mixture: {
          namespaced: true,
          modules: {
            confModule,
            caches,
          },
        },
        fxgProdSuggest,
        common,
  }
})
